// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyRequestList_container__2PA3n","header":"CompanyRequestList_header__1Npkl","title":"CompanyRequestList_title__25-3z","filter":"CompanyRequestList_filter__29k12"};